export * from '@primeuix/themes/lara/multiselect';
export { default } from '@primeuix/themes/lara/multiselect';
